import { useContext, useState } from 'react'
import { getFormCMSContent } from '../../services/api/cms'
import { SiteContext } from '../../services/context/SiteContext'
import { FRANCHISE_LOGO_URL } from '../../services/variables'
import * as S from './Header.styled'
import RegisterYourInterestModal from './RegisterYourInterestModal'

export const FranchiseHeaderForm = () => {
  const { siteSettings, formBrochure } = useContext(SiteContext)
  const [enquireNowForm, setEnquireNowForm] = useState(null)

  const getFormFields = async () => {
    const form_fields = await getFormCMSContent(null, {
      slug: siteSettings?.enquire_now_form
    })
    setEnquireNowForm(form_fields)
  }

  if (!enquireNowForm && siteSettings?.enquire_now_form) {
    getFormFields()
  }

  return (
    <RegisterYourInterestModal
      button={<S.Button>ENQUIRE NOW</S.Button>}
      form={formBrochure || enquireNowForm}
      downloadFileOnSuccess={true}
      fileUrl={formBrochure && formBrochure.linkUrl ? formBrochure.linkUrl : ''}
    />
  )
}

export const FranChiseLogo = () => {
  return (
    <S.Logo href='/'>
      <img src={FRANCHISE_LOGO_URL} alt='' />
    </S.Logo>
  )
}

export const Header = () => {
  const { siteInfor, formBrochure } = useContext(SiteContext)

  return (
    <S.Header>
      <FranChiseLogo />
      {siteInfor?.isDownloadable &&
      !formBrochure?.requireAuthEverytime &&
      formBrochure?.linkUrl ? (
        <S.Link href={formBrochure.linkUrl} target={'_blank'} download>
          {'ENQUIRE NOW'}
        </S.Link>
      ) : (
        <FranchiseHeaderForm />
      )}
    </S.Header>
  )
}

export default Header
